// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root[data-theme=theme-dark] {
  --bg:#202020;
  --bg-start: #101010;
  --bg-end: #808080;
  --fg: white;
  --fg-heading: white;
  --hover: rgb(255,200,0);
  --hover-start: #000050;
  --hover-end: #0000f0;
  --gradient: linear-gradient(45deg, var(--bg-start), var(--bg-end));
  --gradient-hover: linear-gradient(223deg, var(--hover-start), var(--hover-end));
  --button: linear-gradient(45deg, #95a5db, #02015c);
  --button-text: white;
  --button-hover: linear-gradient(45deg, #dbda95, #df0d0d);
  --button-hover-text: black;
  --button-active: linear-gradient(45deg, #021403, #2cb809);
  --button-active-text: blue;
  --button-disabled: linear-gradient(45deg, #0c0c0c, #202020);
  --button-disabled-text: gray;
  --gradient-heading: linear-gradient(45deg, #d7e421, #2e0000);
  --fg-heading: var(--fginv);
  --strong-color: yellow;
  --svg-color: rgb(0, 204, 255);
  --svg-hover-color: red;
  --dark-color: rgb(116, 75, 0);
  --faint-color: #9c9b9b;
  --disabled-color: rgb(85, 82, 82);
  --outline: 0.1rem solid white;
  --outline-hover: 0.14rem solid yellow;
  --outline-active: 0.14rem solid red;
  --outline-disabled: 0.1rem solid black;
  --overlay-background: rgba(0,0,0, 0.7);
  --overlay-blur: 25;
}

:root[data-theme=theme-light] {
  --bg:#c0c0c0;
  --bg-start: #808080;
  --bg-end: #ffffff;
  --fg: black;
  --fg-heading: white;
  --hover: rgb(104, 83, 7);
  --hover-start: #000050;
  --hover-end: #0000f0;
  --gradient: linear-gradient(45deg, var(--bg-start), var(--bg-end));
  --gradient-hover: linear-gradient(223deg, var(--hover-start), var(--hover-end));
  --button: linear-gradient(45deg, #95a5db, #02015c);
  --button-hover: linear-gradient(45deg, #dbda95, #df0d0d);
  --button-active: linear-gradient(45deg, #021403, #2cb809);
  --button-disabled: linear-gradient(45deg, #5c5c5a, #202020);
  --button-text: white;
  --button-hover-text: black;
  --gradient-heading: linear-gradient(45deg, #1a5aa3, #0a0122);
  --fg-heading: var(--fginv);
  --comment-color: #1f1100;
  --strong-color: rgb(0, 38, 255);
  --reverse-strong-color: rgb(211, 164, 8);
  --em-color: rgb(38, 24, 56);
  --svg-color: rgb(81, 212, 245);
  --svg-hover-color: red;
  --dark-color: rgb(64, 65, 136);
  --faint-color: #7c6542;
  --disabled-color: gray;
  --outline: 0.2rem solid rgb(21, 2, 75);
  --outline-hover: 0.25rem solid yellow;
  --outline-disabled: 0.1rem solid black;
  --outline-active: 0.3rem solid red;
  --overlay-background: rgba(0,0,0, 0.7);
}

:root {
  --font-size: 1em;
  --font-family: Verdana, Geneva, Tahoma, sans-serif;
  --bodyheight: 97vh;
  --headerheight: 6vh;
  --page-width: 60vw;
  --border-radius: 0.4rem;
  --tb-button-size: 24px;
  --shadow: 12px 10px 12px #000;
  --near-shadow: 8px 6px 8px #000;
  --edit-zindex: 220;
  --toolbar-zindex: 210;
  --overlay-zindex: 200;
}

* {
  transition: background 0.3s ease, color 0.3s ease;
  border-radius: var(--border-radius);
  border: none;
  outline: none;
  background: var(--bg);
  color: var(--fg);
  font-size: var(--font-size);
  font-family: var(--font-family);
  font-weight: bold;
}
* button {
  background: var(--button);
  box-shadow: var(--shadow);
  color: var(--button-text);
  font-size: calc(0.8 * var(--font-size));
  font-weight: bold;
  height: 1.5rem;
  width: auto;
  line-height: 1.4rem;
  margin: 0em 1em 1em 0.5em;
  outline: var(--outline);
  cursor: pointer;
}
* button:hover {
  cursor: pointer;
  background: var(--button-hover);
  color: var(--button-text-hover);
}
* button:focus, * button:active {
  background: var(--button-hover);
  color: var(--button-text-hover);
  cursor: default;
}
* strong,
* em,
* a,
* div,
* thead,
* tr,
* th,
* p {
  background: transparent;
}
* a {
  color: var(--strong-color);
}
* strong {
  color: var(--strong-color);
  font-weight: bolder;
  margin-left: 0.3em;
  margin-right: 0.3em;
}
* em {
  color: var(--em-color);
  font-style: italic;
  margin-left: 0.3em;
  margin-right: 0.3em;
}
* label {
  font-weight: bold;
  background: transparent;
}
* a {
  font-weight: bold;
  text-decoration: none;
  color: var(--strong-color);
}
* figcaption {
  background: transparent;
  color: var(--comment-color);
  font-style: italic;
}
* svg {
  width: 28px;
  height: auto;
}
@media only screen and (max-width: 600px) {
  * {
    --bodyheight: 97vh;
    --headerheight: 6vh;
    --page-width: 98vw;
  }
  * form button,
  * form input {
    min-width: unset !important;
  }
}

h1 {
  font-size: 2em;
}

h2 {
  font-size: 1.5em;
}

h1, h2 {
  font-weight: bold;
  background: var(--gradient-heading);
  color: var(--bg);
}

h3 {
  background: transparent;
  color: var(--fg);
  padding: 0.2em !important;
}

h1, h2, h3 {
  box-shadow: var(--shadow);
  text-align: center;
  padding: 0.4em;
  outline: var(--outline);
}
h1 span, h2 span, h3 span {
  color: inherit;
}

@media screen and (max-width: 600px) {
  h1, h2, h3 {
    font-size: inherit;
  }
}
select {
  color: var(--fg);
}

section {
  display: inline-flex;
  position: relative;
  font-weight: bold;
  width: inherit;
  min-height: 2rem;
  margin: 10px;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
}
section .edit {
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  outline: 2px solid var(--strong-color);
}
section .content {
  display: stretch;
  width: -webkit-fill-available;
}
section .comment {
  margin: 1em;
  text-align: center;
  background-color: transparent;
  color: var(--fg);
  border: none;
  font-style: italic;
  font-weight: bold;
}
section .comment:hover {
  outline: var(--outline-hover);
}
section .comment:focus {
  outline: var(--outline-active);
}

@media screen and (max-width: 600px) {
  section {
    width: unset;
    margin: 0px;
  }
  section .content {
    padding: unset;
  }
}
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@media screen and (max-width: 600px) {
  h1,
  h2,
  h3 {
    padding: 0.2em;
  }
}
body {
  display: grid;
  height: var(--bodyheight);
  padding: 10px;
  gap: 10px;
  grid-template-columns: 1.1fr 4fr 1fr;
  grid-template-rows: 2fr 30fr 1fr;
  grid-template-areas: "header header header" "left page right" "footer footer footer";
}

.mid {
  position: absolute;
  width: var(--page-width);
  left: calc((100vw - var(--page-width)) / 2);
  top: 0vh;
}
.mid nav {
  display: flex;
  grid-area: header;
  height: var(--headerheight);
  justify-content: space-between;
}
.mid nav .title {
  align-content: center;
  font-weight: bold;
  font-size: xx-large !important;
  margin-top: 0.7em;
  text-shadow: var(--near-shadow);
}
.mid nav #sitelogo {
  margin-right: 8px;
  margin-top: 8px;
}
.mid main {
  display: flex;
  flex-flow: column;
  margin-top: 1em;
}
.mid footer {
  display: flex;
  position: fixed;
  background: var(--gradient-heading);
  color: var(--fg-heading);
  width: calc(0.9 * var(--page-width));
  bottom: 8px;
  margin-left: 2%;
  padding-left: 4px;
  padding-right: 4px;
  align-items: center;
  box-shadow: var(--shadow);
  justify-content: space-between;
}
.mid footer .sitename {
  grid-area: "left";
  background: transparent;
  color: var(--bg);
}
.mid footer .sitecontact {
  grid-area: "mid";
  background: transparent;
  color: var(--bg);
}
.mid footer .version,
.mid footer a {
  grid-area: "right";
  background: transparent;
  color: var(--reverse-strong-color) !important;
  font-size: 1em;
  font-weight: normal;
}

.left {
  grid-area: left;
  position: fixed;
}

.right {
  display: flex;
  grid-area: right;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: flex-start;
}
.right .help {
  display: block;
  position: relative;
  left: 1em;
}
.right .help .heading-help {
  background: var(--gradient-heading);
  color: var(--bg);
  box-shadow: var(--shadow);
  margin: 0em 0em 0em 0.5em;
  outline: var(--outline);
}

@media screen and (max-width: 600px) {
  .mid {
    left: 0;
    width: unset;
  }
  .mid nav .title {
    font-size: x-large !important;
  }
  #sitelogo {
    width: 14vw;
    margin-top: 2px;
    margin-right: 5px;
  }
  #sitelogo {
    margin-right: 0px;
  }
  .left,
  .right {
    display: none;
  }
  body {
    gap: 7px;
    padding: 0px;
    height: 96vh;
    grid-template-columns: 0fr 1fr 0fr;
  }
  main {
    width: 90vw;
    margin-left: 6px;
    margin-top: 3em;
    width: 96vw;
  }
  footer {
    width: 93%;
    height: 4em;
    justify-content: center;
    flex-wrap: wrap;
    font-size: small;
    flex-direction: column;
  }
}
.outline-btn {
  position: absolute;
  width: 24px;
  height: 24px;
  cursor: pointer;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.5s, transform 0.15s;
  padding: 4px;
  background: transparent;
}

/* Fade-in vid hover */
section:hover .outline-btn {
  opacity: 1;
}

section:hover .outline-btn:hover {
  opacity: 1;
  transform: scale(1.2);
}

.left-top, .public-btn, .up-btn {
  bottom: unset !important;
  right: unset !important;
  left: -24px;
  top: -12px;
}

.left-bottom, .private-btn, .down-btn {
  top: unset !important;
  right: unset !important;
  left: -24px;
  bottom: -24px;
}

.right-top, .abort-btn, .edit-btn {
  left: unset !important;
  bottom: unset !important;
  right: -24px;
  top: -12px;
}

.right-bottom, .delete-btn, .save-btn {
  left: unset !important;
  top: unset !important;
  right: -24px;
  bottom: -24px;
}

.save-btn {
  stroke: green;
  fill: green;
  opacity: 1 !important;
}

.up-btn {
  fill: var(--fg);
  stroke: var(--fg);
}

.public-btn {
  fill: green;
  stroke: green;
  opacity: 1 !important;
}

.down-btn {
  fill: var(--fg);
  stroke: var(--fg);
}

.private-btn {
  fill: red;
  stroke: red;
  opacity: 1 !important;
}

.edit-btn {
  fill: green;
  stroke: green;
}

.delete-btn {
  stroke: red;
  fill: red;
}

.abort-btn {
  stroke: red;
  fill: red;
  opacity: 1 !important;
}

.red-border {
  outline: 4px solid red !important;
}

.green-border {
  outline: 4px solid green !important;
}

.pop {
  margin: 20px;
  top: 50%;
  left: 50%;
  position: fixed;
  box-shadow: var(--shadow);
  transform: translate(-50%, -50%);
  z-index: 600;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  font-weight: bold;
}
.pop div {
  display: flow-root;
  text-align: center;
}
.pop input {
  background: var(--gradient);
  color: var(--fg);
  height: 1.5rem;
  width: max-content;
  line-height: 1rem;
  margin: 4px;
  font-weight: bold;
  box-shadow: var(--shadow);
  min-width: var(--min-input-width);
  max-width: var(--max-input-width);
}
.pop input:hover {
  background: var(--gradient-hover);
}
.pop .error {
  background: red;
  color: wheat;
}
.pop .message {
  position: relative;
}
.pop .error {
  position: relative;
}

form {
  display: flex;
  flex-direction: column;
  z-index: 500;
  padding: 1em 1em 4em 1em;
  margin-top: 0rem;
  max-height: unset !important;
  background: var(--gradient);
  outline: var(--outline);
  box-shadow: var(--shadow);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: calc(0.6 * var(--page-width));
  min-width: 10vw;
  width: min-content;
}
form th {
  font-weight: bold;
}
form td {
  font-weight: unset;
  font-size: small;
}
form .buttons {
  display: flex;
  flex-flow: nowrap;
  justify-content: space-evenly;
  flex-direction: column;
  background: transparent;
  margin: 1em 0em 0em 0em;
}
form button {
  margin: 1em 1em 1em 1em;
}
form input {
  background: var(--button);
  outline: var(--outline);
  height: 1.5em;
  margin: 0.3em 0em 0.5em 0em;
  box-shadow: var(--near-shadow);
  padding: 0em 0em 0em 0.5em;
}
form input:hover {
  background: var(--button-hover);
  color: var(--button-hover-text);
}
form input:active form input:focus {
  background: var(--button-active);
  color: var(--fg);
}
form textarea {
  background: var(--button);
  outline: var(--outline);
  box-shadow: var(--near-shadow);
  resize: none;
}
form textarea:hover {
  background: var(--button-hover);
  color: var(--button-hover-text);
}
form textarea:active form textarea:focus {
  background: var(--button-active);
  color: var(--fg);
}
form select {
  background: var(--button);
  outline: var(--outline);
  box-shadow: var(--near-shadow);
}
form select:hover {
  background: var(--button-hover);
  color: var(--button-hover-text);
}
form select:active form select:focus {
  background: var(--button-active);
  color: var(--fg);
}
form option {
  background: var(--fg);
  color: var(--bg-end);
}
form option:hover {
  background: var(--button-hover);
  color: var(--button-hover-text);
}
form option:active form option:focus {
  background: var(--button-active);
  color: var(--fg);
}
form hr {
  margin: 12px;
  color: var(--line-color);
}
form div {
  display: grid;
}
form .listbox {
  display: inline;
}
form .listbox select {
  width: 100%;
}
form iframe {
  width: auto;
  height: 200px;
}
form .content {
  display: flex;
  flex-flow: column;
}
form input[type=checkbox] {
  height: 20px;
  width: 20px;
}
form .inputDiv {
  display: -ms-grid !important;
  display: grid !important;
  -ms-grid-columns: 40% 60%;
  grid-template-columns: 40% 60%;
  gap: 0.7rem;
  margin: 0.7rem;
}
form table {
  display: inline-table;
  width: 56vw;
}
form th {
  text-align: left;
}

.formcontainer {
  display: flex;
  justify-content: center;
  -ms-flex-direction: column;
  flex-direction: column;
}

.log {
  min-width: 98vw !important;
}
.log table {
  width: 100%;
}
.log button {
  position: fixed;
  bottom: 0em;
  width: 95%;
}

.pageedit {
  width: 40vw;
}

@media only screen and (max-width: 600px) {
  form button,
  form input {
    min-width: unset !important;
  }
}
aside {
  flex-flow: column;
  margin-top: 1rem;
  display: flex;
  width: -webkit-fill-available;
}
aside .page {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  display: -ms-grid;
  display: flex;
  justify-content: start;
  width: inherit;
}
aside .submenu {
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  margin: 0.5em 1em 1em 0.5em;
  width: inherit;
}
aside .sub {
  -ms-flex-direction: row;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 2rem;
  width: inherit;
  display: flex;
  display: flex;
}
aside button {
  width: fit-content;
}
aside button.group-btn {
  background: rgb(133, 74, 2) !important;
}
aside button.page-btn {
  background: rgb(9, 78, 3) !important;
}
aside .addGroup {
  display: flex;
  flex-direction: column;
  margin: 4px;
  height: 2.5em;
  background: var(--button-hover);
}
aside .addPage {
  display: flex;
  flex-direction: column;
  margin: 4px;
  height: 2.5em;
  background: var(--button-active);
}

select {
  height: 2rem;
  box-shadow: var(--shadow);
}

#menutoggler {
  background-color: var(--dark-color);
  font-size: xx-large;
  width: 36px;
  height: 36px;
  box-shadow: var(--near-shadow);
  border-radius: 4px;
  margin-left: 8px;
  margin-top: 1rem;
  line-height: 1em;
  text-align: center;
  cursor: pointer;
}

.addMenu {
  display: flex;
  flex-flow: column;
  margin-top: 1rem;
}
.addMenu button {
  width: inherit;
}

.adminMenu {
  display: flex;
  flex-flow: column;
  margin-top: 1rem;
}
.adminMenu button {
  width: inherit;
}

@media screen and (max-width: 600px) {
  .addMenu {
    display: none;
  }
  #menutoggler {
    height: auto;
    width: 32px;
    box-shadow: var(--near-shadow);
  }
  aside {
    margin-top: 0.4em;
  }
  aside div {
    margin-left: 0.4em;
  }
}
.add-wrapper {
  justify-content: center;
  transition: scale 0.25s ease-in-out;
  transform-origin: top left;
  top: -2em;
  position: relative;
  line-height: 0em;
}

.audio-wrapper {
  display: block;
  text-align: center;
}
.audio-wrapper audio {
  width: -webkit-fill-available;
  background: var(--gradient-heading);
  outline: var(--outline);
}
.audio-wrapper figcaption {
  background: transparent;
  color: var(--comment-color);
  font-style: italic;
  margin-top: 0.5em;
}

.heading-wrapper {
  display: block;
  text-align: center;
}
.heading-wrapper h1,
.heading-wrapper h2,
.heading-wrapper h3 {
  background: var(--gradient-heading);
  color: var(--bg);
  box-shadow: var(--shadow);
}

@media screen and (max-width: 600px) {
  .heading-wrapper {
    margin-bottom: 2em;
  }
}
.image-wrapper {
  display: inline-flex !important;
  transition: scale 0.25s ease-in-out;
  transform-origin: top left;
  max-height: 80vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin-bottom: 1em;
  max-height: 60vh;
}
.image-wrapper img:hover {
  cursor: pointer;
}
.image-wrapper figure {
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 80%;
  max-height: 80%;
}
.image-wrapper #image-comment {
  text-align: center;
}
.image-wrapper .clicknote {
  font-size: small;
  font-weight: normal;
  font-style: italic;
  text-align: center;
  color: var(--disabled-color);
  z-index: 100;
}

.fullscreen-image {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: zoom-out;
  width: 100%;
  height: 100%;
}

.fullscreen-image img {
  display: block !important;
  width: auto !important;
  height: auto !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  cursor: zoom-out;
}

@media screen and (max-width: 600px) {
  .image {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 100%;
    grid-template-columns: 100%;
    flex-flow: wrap;
    justify-content: center;
  }
}
.list-wrapper {
  padding: 0em 0em 0em 1em;
}

.spotify-wrapper {
  display: block;
  text-align: center;
  aspect-ratio: 16/1;
}
.spotify-wrapper figcaption {
  margin-top: 1em;
  position: relative;
}
.spotify-wrapper iframe {
  width: -webkit-fill-available;
  height: 153px;
}

@media screen and (max-width: 600px) {
  .spotify-wrapper figcaption {
    margin-top: 5em;
  }
}
.text-wrapper {
  display: block;
}
.text-wrapper a {
  cursor: pointer;
  color: var(--strong-color);
}

.video-wrapper {
  display: block;
  justify-content: center;
  width: -moz-available;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}
.video-wrapper figure {
  margin: 0;
}
.video-wrapper figure video {
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
}
.video-wrapper figure figcaption {
  text-align: center;
  margin-top: 1em;
}

@media screen and (max-width: 600px) {
  .video-wrapper {
    width: 80vw;
  }
}
.youtube-wrapper {
  aspect-ratio: 16/9;
  height: fit-content;
}
.youtube-wrapper iframe {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 600px) {
  .youtube figcaption {
    margin-top: 5em;
  }
}
.toolbar {
  display: flex;
  height: var(--tb-button-size);
  z-index: var(--toolbar-zindex);
  margin-bottom: 0.5em;
  margin-top: 0.1em;
  justify-content: space-evenly;
}

.tbgroup {
  flex-flow: row;
  margin: -4px 4px 0px 10px;
  padding: 4px;
  height: 32px;
}

.toolbar button {
  width: 2em !important;
  box-shadow: 4px 6px 5px #000;
  margin: 0.1em;
  margin: 2px;
  height: 2em !important;
}

.toolbar button:hover {
  scale: 1.2;
  box-shadow: var(--shadow);
}

.toolbar-btn {
  height: 1.5rem;
  line-height: 1rem;
  margin: 0.4rem;
  box-shadow: var(--shadow);
  width: max-content;
  padding-right: 1em;
}

.btnNone {
  box-shadow: none;
}

.icon {
  margin-right: 0.5em;
}

.editTools {
  outline: var(--outline);
  padding: 0.5em 0em 0em 0em;
  background: var(--bg-start);
  box-shadow: var(--shadow);
  margin: 0em 0em 1em 0em;
  z-index: 500;
}

.disabled {
  background: var(--button-disabled);
  color: var(--button-disabled-text);
  cursor: not-allowed;
}

.active {
  background: var(--button-active);
  color: var(--button-active-text);
  cursor: pointer;
}

.edit-container {
  padding: 1em;
}

.edit {
  z-index: var(--edit-zindex);
  position: relative;
  box-shadow: var(--shadow);
}

.debugger {
  display: block;
  width: 18vw;
  height: auto;
  z-index: 99999;
  position: fixed;
  left: 0.1vw;
  top: 6vh;
  padding: 1em;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: var(--overlay-blur);
  backdrop-filter: var(--overlay-blur);
  z-index: var(--overlay-zindex);
  background: var(--overlay-background);
}

.border-img {
  display: block;
}

.border-img:hover {
  display: block;
}

.theme {
  display: flex;
  background: transparent;
  -ms-flex-direction: column;
  flex-direction: column;
  align-items: center;
}

.theme-selectors {
  display: flex;
  -ms-flex-direction: column;
  flex-direction: row;
}

.theme-dark {
  background: linear-gradient(45deg, rgb(126, 126, 126), black) !important;
}

.theme-light {
  background: linear-gradient(45deg, rgb(92, 91, 91), rgb(214, 213, 213)) !important;
}

.theme-dark,
.theme-light {
  width: 24px;
  height: 24px;
  margin-top: 1em;
  border-radius: 50%;
}

.theme-container {
  height: 2em;
  width: 80%;
  display: flex;
  justify-content: space-around;
  margin-left: 10%;
  margin-bottom: 2%;
}

.theme-item {
  width: 1.5em;
  margin-left: 0.5em;
  border-radius: 8px;
  box-shadow: var(--shadow);
  height: 1.5em;
  border-radius: 50%;
  margin-top: 0.2em;
}

.theme-switcher {
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
  cursor: pointer;
  border: none;
  background: var(--button);
  color: var(--button-text);
}
.theme-switcher:hover {
  background: var(--button-hover);
  color: var(--button-hover-text);
}
.theme-switcher .page {
  margin: 4px;
}

.theme-dark {
  background: linear-gradient(45deg, rgb(126, 126, 126), black) !important;
}

.theme-light {
  background: linear-gradient(45deg, rgb(92, 91, 91), rgb(214, 213, 213)) !important;
}

@media screen and (max-width: 600px) {
  .theme-dark,
  .theme-light {
    width: 10px;
    height: 10px;
    margin-top: 1em;
    margin-left: 0.5em;
  }
  .theme-switcher {
    background: var(--button);
    color: var(--button-text);
    font-size: 1rem;
    margin-left: 0.3em;
  }
  .theme-switcher:hover {
    background: var(--button-hover);
    color: var(--button-hover-text);
  }
}
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.hidden {
  display: none !important;
}

.disabled {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.edit-border {
  outline: var(--outline);
  border-radius: 0.4em;
  padding: 1em;
}
.edit-border:hover {
  outline: var(--outline-hover);
}
.edit-border:active {
  outline: var(--outline-active);
}

.shadow {
  box-shadow: var(--shadow);
}

.listbox {
  display: flex;
  gap: 0.5rem;
  -ms-flex-direction: column;
  flex-direction: column;
}

.selector {
  display: flex;
  height: auto;
  padding: 0.5em;
  -ms-flex-direction: column;
  flex-direction: column;
  z-index: 1000;
}

.viewport {
  overflow: hidden;
  width: 100%;
}

.page {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  display: -ms-grid;
  display: grid;
  justify-content: start;
}`, "",{"version":3,"sources":["webpack://./frontend/scss/_dark.scss","webpack://./frontend/scss/style.scss","webpack://./frontend/scss/_light.scss","webpack://./frontend/scss/_root.scss","webpack://./frontend/scss/_base.scss","webpack://./frontend/scss/_layout.scss","webpack://./frontend/scss/_outline.scss","webpack://./frontend/scss/_dialogs.scss","webpack://./frontend/scss/_menu.scss","webpack://./frontend/scss/_wrappers.scss","webpack://./frontend/scss/_toolbar.scss","webpack://./frontend/scss/_edit.scss","webpack://./frontend/scss/_theme.scss"],"names":[],"mappings":"AACA;EACI,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EAEA,uBAAA;EACA,sBAAA;EACA,oBAAA;EAEA,kEAAA;EACA,+EAAA;EAEA,kDAAA;EACA,oBAAA;EAEA,wDAAA;EACA,0BAAA;EAEA,yDAAA;EACA,0BAAA;EAEA,2DAAA;EACA,4BAAA;EAEA,4DAAA;EACA,0BAAA;EAEA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,iCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,mCAAA;EACA,sCAAA;EAEA,sCAAA;EACA,kBAAA;ACVJ;;AChCA;EACI,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EAGA,wBAAA;EACA,sBAAA;EACA,oBAAA;EAEA,kEAAA;EACA,+EAAA;EAEA,kDAAA;EACA,wDAAA;EACA,yDAAA;EACA,2DAAA;EACA,oBAAA;EACA,0BAAA;EAEA,4DAAA;EACA,0BAAA;EAEA,wBAAA;EACA,+BAAA;EACA,wCAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,sBAAA;EAEA,sCAAA;EACA,qCAAA;EACA,sCAAA;EACA,kCAAA;EAEA,sCAAA;AD2BJ;;AEjEA;EACI,gBAAA;EACA,kDAAA;EAEA,kBAAA;EACA,mBAAA;EAEA,kBAAA;EAGA,uBAAA;EACA,sBAAA;EAEA,6BAAA;EACA,+BAAA;EAEA,kBAAA;EACA,qBAAA;EACA,qBAAA;AF8DJ;;AE1DA;EACI,iDAAA;EACA,mCAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,2BAAA;EACA,+BAAA;EACA,iBAAA;AF6DJ;AE3DI;EACI,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AF6DR;AE3DQ;EACI,eAAA;EACA,+BAAA;EACA,+BAAA;AF6DZ;AE1DQ;EAEI,+BAAA;EACA,+BAAA;EACA,eAAA;AF2DZ;AEhDI;;;;;;;;EAQI,uBAAA;AFkDR;AE/CI;EACI,0BAAA;AFiDR;AE9CI;EACI,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AFgDR;AE7CI;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AF+CR;AE5CI;EACI,iBAAA;EACA,uBAAA;AF8CR;AE1CI;EACI,iBAAA;EACA,qBAAA;EACA,0BAAA;AF4CR;AEzCI;EACI,uBAAA;EACA,2BAAA;EACA,kBAAA;AF2CR;AExCI;EACI,WAAA;EACA,YAAA;AF0CR;AEtCI;EAlGJ;IAqGQ,kBAAA;IACA,mBAAA;IACA,kBAAA;EFuCN;EEnCU;;IAEI,2BAAA;EFqCd;AACF;;AG1KA;EACI,cAAA;AH6KJ;;AG1KA;EACI,gBAAA;AH6KJ;;AG1KA;EAEI,iBAAA;EACA,mCAAA;EACA,gBAAA;AH4KJ;;AGzKA;EACI,uBAAA;EACA,gBAAA;EACA,yBAAA;AH4KJ;;AGzKA;EACI,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;AH4KJ;AG1KI;EACI,cAAA;AH4KR;;AGxKA;EACI;IACI,kBAAA;EH2KN;AACF;AGxKA;EACI,gBAAA;AH0KJ;;AGvKA;EACI,oBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AHyKJ;AGtKI;EACI,aAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;AHwKR;AGrKI;EACI,gBAAA;EACA,6BAAA;AHuKR;AGpKI;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AHsKR;AGpKQ;EACI,6BAAA;AHsKZ;AGnKQ;EACI,8BAAA;AHqKZ;;AG/JA;EAEI;IACI,YAAA;IACA,WAAA;EHiKN;EG/JM;IACI,cAAA;EHiKV;AACF;AG3JA;EACI;IACI,UAAA;EH6JN;EG1JE;IACI,UAAA;EH4JN;EGzJE;IACI,UAAA;EH2JN;EGxJE;IACI,UAAA;EH0JN;AACF;AGvJA;EAEI;;;IAGI,cAAA;EHwJN;AACF;AIpRA;EACI,aAAA;EAEA,yBAAA;EACA,aAAA;EACA,SAAA;EAEA,oCAAA;EACA,gCAAA;EACA,oFAAA;AJoRJ;;AI1QA;EACI,kBAAA;EACA,wBAAA;EACA,2CAAA;EACA,QAAA;AJ6QJ;AI3QI;EACI,aAAA;EACA,iBAAA;EAEA,2BAAA;EAEA,8BAAA;AJ2QR;AIzQQ;EACI,qBAAA;EACA,iBAAA;EACA,8BAAA;EACA,iBAAA;EACA,+BAAA;AJ2QZ;AIxQQ;EACI,iBAAA;EACA,eAAA;AJ0QZ;AItQI;EACI,aAAA;EACA,iBAAA;EACA,eAAA;AJwQR;AIpQI;EACI,aAAA;EACA,eAAA;EAEA,mCAAA;EACA,wBAAA;EAEA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,8BAAA;AJmQR;AIjQQ;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;AJmQZ;AIjQQ;EACI,gBAAA;EACA,uBAAA;EACA,gBAAA;AJmQZ;AIhQQ;;EAEI,kBAAA;EACA,uBAAA;EACA,6CAAA;EACA,cAAA;EACA,mBAAA;AJkQZ;;AIzPA;EACI,eAAA;EACA,eAAA;AJ4PJ;;AIrPA;EACI,aAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;AJwPJ;AItPI;EACI,cAAA;EACA,kBAAA;EACA,SAAA;AJwPR;AItPQ;EACI,mCAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;AJwPZ;;AIlPA;EAEI;IACI,OAAA;IACA,YAAA;EJoPN;EIjPU;IACI,6BAAA;EJmPd;EI7OE;IACI,WAAA;IACA,eAAA;IACA,iBAAA;EJ+ON;EI5OE;IACI,iBAAA;EJ8ON;EI3OE;;IAEI,aAAA;EJ6ON;EI1OE;IACI,QAAA;IACA,YAAA;IACA,YAAA;IACA,kCAAA;EJ4ON;EIzOE;IACI,WAAA;IACA,gBAAA;IACA,eAAA;IACA,WAAA;EJ2ON;EIxOE;IACI,UAAA;IACA,WAAA;IACA,uBAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;EJ0ON;AACF;AK/ZA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,YAAA;EACA,uBAAA;ALiaJ;;AK7ZA,sBAAA;AACA;EACI,UAAA;ALgaJ;;AK7ZA;EACI,UAAA;EACA,qBAAA;ALgaJ;;AK5ZA;EACI,wBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;AL+ZJ;;AK5ZA;EACI,qBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;AL+ZJ;;AK5ZA;EACI,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,UAAA;AL+ZJ;;AK5ZA;EACI,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;AL+ZJ;;AK5ZA;EAEI,aAAA;EACA,WAAA;EACA,qBAAA;AL8ZJ;;AK3ZA;EAEI,eAAA;EACA,iBAAA;AL6ZJ;;AK1ZA;EAEI,WAAA;EACA,aAAA;EACA,qBAAA;AL4ZJ;;AKzZA;EAEI,eAAA;EACA,iBAAA;AL2ZJ;;AKxZA;EAEI,SAAA;EACA,WAAA;EACA,qBAAA;AL0ZJ;;AKvZA;EAEI,WAAA;EACA,aAAA;ALyZJ;;AKtZA;EAEI,WAAA;EACA,SAAA;ALwZJ;;AKrZA;EAEI,WAAA;EACA,SAAA;EACA,qBAAA;ALuZJ;;AKnZA;EACI,iCAAA;ALsZJ;;AKnZA;EACI,mCAAA;ALsZJ;;AMvgBA;EACI,YAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EACA,sBAAA;EACA,iBAAA;AN0gBJ;AMvgBI;EACI,kBAAA;EACA,kBAAA;ANygBR;AMrgBI;EACI,2BAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EAEA,yBAAA;EAEA,iCAAA;EACA,iCAAA;ANqgBR;AMngBQ;EACI,iCAAA;ANqgBZ;AMhgBI;EACI,eAAA;EACA,YAAA;ANkgBR;AM/fI;EACI,kBAAA;ANigBR;AM7fI;EACI,kBAAA;AN+fR;;AM3fA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AN8fJ;AM5fI;EACI,iBAAA;AN8fR;AM3fI;EACI,kBAAA;EACA,gBAAA;AN6fR;AM1fI;EACI,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AN4fR;AMzfI;EACI,uBAAA;AN2fR;AMxfI;EACI,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,0BAAA;AN0fR;AMxfQ;EACI,+BAAA;EACA,+BAAA;AN0fZ;AMvfQ;EACI,gCAAA;EACA,gBAAA;ANyfZ;AMpfI;EACI,yBAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;ANsfR;AMpfQ;EACI,+BAAA;EACA,+BAAA;ANsfZ;AMnfQ;EACI,gCAAA;EACA,gBAAA;ANqfZ;AMhfI;EACI,yBAAA;EACA,uBAAA;EACA,8BAAA;ANkfR;AMhfQ;EACI,+BAAA;EACA,+BAAA;ANkfZ;AM/eQ;EACI,gCAAA;EACA,gBAAA;ANifZ;AM5eI;EACI,qBAAA;EACA,oBAAA;AN8eR;AM5eQ;EACI,+BAAA;EACA,+BAAA;AN8eZ;AM3eQ;EACI,gCAAA;EACA,gBAAA;AN6eZ;AMxeI;EACI,YAAA;EACA,wBAAA;AN0eR;AMveI;EACI,aAAA;ANyeR;AMteI;EACI,eAAA;ANweR;AMteQ;EACI,WAAA;ANweZ;AMpeI;EACI,WAAA;EACA,aAAA;ANseR;AMneI;EACI,aAAA;EACA,iBAAA;ANqeR;AMleI;EACI,YAAA;EACA,WAAA;ANoeR;AMjeI;EACI,4BAAA;EACA,wBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;EACA,cAAA;ANmeR;AMheI;EACI,qBAAA;EACA,WAAA;ANkeR;AM/dI;EACI,gBAAA;ANieR;;AM5dA;EACI,aAAA;EACA,uBAAA;EACA,0BAAA;EACA,sBAAA;AN+dJ;;AM5dA;EACI,0BAAA;AN+dJ;AM7dI;EACI,WAAA;AN+dR;AM5dI;EACI,eAAA;EACA,WAAA;EACA,UAAA;AN8dR;;AM1dA;EACI,WAAA;AN6dJ;;AMxdA;EAGQ;;IAEI,2BAAA;ENydV;AACF;AOptBA;EACI,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;APstBJ;AOptBI;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;APstBR;AOntBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;APqtBR;AOltBI;EACI,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;APotBR;AOjtBI;EACI,kBAAA;APmtBR;AOhtBI;EACI,sCAAA;APktBR;AO/sBI;EACI,oCAAA;APitBR;AO9sBI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;APgtBR;AO7sBI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;AP+sBR;;AO1sBA;EACI,YAAA;EACA,yBAAA;AP6sBJ;;AO1sBA;EACI,mCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AP6sBJ;;AO1sBA;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;AP6sBJ;AO1sBI;EACI,cAAA;AP4sBR;;AOvsBA;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;AP0sBJ;AOvsBI;EACI,cAAA;APysBR;;AOpsBA;EAEI;IACI,aAAA;EPssBN;EOnsBE;IACI,YAAA;IACA,WAAA;IACA,8BAAA;EPqsBN;EOlsBE;IACI,iBAAA;EPosBN;EOlsBM;IACI,kBAAA;EPosBV;AACF;AQ5zBA;EACI,uBAAA;EACA,mCAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AR8zBJ;;AQxzBA;EACI,cAAA;EACA,kBAAA;AR2zBJ;AQzzBI;EACI,6BAAA;EACA,mCAAA;EACA,uBAAA;AR2zBR;AQxzBI;EACC,uBAAA;EACA,2BAAA;EACA,kBAAA;EACG,iBAAA;AR0zBR;;AQnzBA;EACI,cAAA;EACA,kBAAA;ARszBJ;AQpzBI;;;EAGI,mCAAA;EACA,gBAAA;EACA,yBAAA;ARszBR;;AQlzBA;EACI;IACI,kBAAA;ERqzBN;AACF;AQ/yBA;EACI,+BAAA;EACA,mCAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ARizBJ;AQ/yBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ARizBR;AQ/yBQ;EACI,eAAA;ARizBZ;AQ5yBI;EACI,WAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AR8yBR;AQ3yBI;EACI,kBAAA;AR6yBR;AQ1yBI;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,YAAA;AR4yBR;;AQnyBA;EACI,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ARsyBJ;;AQnyBA;EACI,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;ARsyBJ;;AQlyBA;EAEI;IACI,iBAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,eAAA;IACA,uBAAA;ERoyBN;AACF;AQ7xBA;EACI,wBAAA;AR+xBJ;;AQzxBA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;AR4xBJ;AQ1xBI;EACI,eAAA;EACA,kBAAA;AR4xBR;AQzxBI;EACI,6BAAA;EACA,aAAA;AR2xBR;;AQvxBA;EAGQ;IACI,eAAA;ERwxBV;AACF;AQhxBA;EACI,cAAA;ARkxBJ;AQhxBI;EACI,eAAA;EACA,0BAAA;ARkxBR;;AQ1wBA;EACI,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AR6wBJ;AQ3wBI;EACI,SAAA;AR6wBR;AQ3wBQ;EACI,6BAAA;EACA,qBAAA;EACA,cAAA;AR6wBZ;AQ1wBQ;EACI,kBAAA;EACA,eAAA;AR4wBZ;;AQtwBA;EAEI;IACI,WAAA;ERwwBN;AACF;AQjwBA;EACI,kBAAA;EACH,mBAAA;ARmwBD;AQjwBI;EACI,WAAA;EACA,YAAA;ARmwBR;;AQ/vBA;EACI;IACI,eAAA;ERkwBN;AACF;ASx/BA;EACC,aAAA;EACA,6BAAA;EACA,8BAAA;EACA,oBAAA;EACA,iBAAA;EACA,6BAAA;AT0/BD;;ASv/BA;EACC,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AT0/BD;;ASv/BA;EACC,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AT0/BD;;ASv/BA;EACI,UAAA;EACA,yBAAA;AT0/BJ;;ASv/BA;EACI,cAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AT0/BJ;;ASv/BA;EACI,gBAAA;AT0/BJ;;ASv/BA;EACI,mBAAA;AT0/BJ;;AUtiCA;EACI,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;AVyiCJ;;AUriCI;EACQ,kCAAA;EACA,kCAAA;EACA,mBAAA;AVwiCZ;;AUriCI;EACQ,gCAAA;EACA,gCAAA;EACA,eAAA;AVwiCZ;;AUriCA;EACI,YAAA;AVwiCJ;;AUpiCA;EACI,2BAAA;EACA,kBAAA;EACA,yBAAA;AVuiCJ;;AUpiCA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;AVuiCJ;;AUpiCA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;EACA,oCAAA;EACA,8BAAA;EACA,qCAAA;AVuiCJ;;AUpiCA;EACI,cAAA;AVuiCJ;;AUpiCA;EACI,cAAA;AVuiCJ;;AWnmCA;EACI,aAAA;EACA,uBAAA;EAEA,0BAAA;EACA,sBAAA;EACA,mBAAA;AXqmCJ;;AWlmCA;EACI,aAAA;EAEA,0BAAA;EACA,mBAAA;AXomCJ;;AWhmCA;EACI,wEAAA;AXmmCJ;;AWhmCA;EACI,kFAAA;AXmmCJ;;AW/lCA;;EAEI,WAAA;EACA,YAAA;EACA,eAAA;EAEA,kBAAA;AXimCJ;;AW7lCA;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AXgmCJ;;AW7lCA;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AXgmCJ;;AW7lCA;EACI,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AXgmCJ;AW9lCI;EACI,+BAAA;EACA,+BAAA;AXgmCR;AW7lCI;EACI,WAAA;AX+lCR;;AW5lCA;EACI,wEAAA;AX+lCJ;;AW5lCA;EACI,kFAAA;AX+lCJ;;AW5lCA;EAEI;;IAEI,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EX8lCN;EW3lCE;IACI,yBAAA;IACA,yBAAA;IACA,eAAA;IACA,kBAAA;EX6lCN;EW3lCM;IACI,+BAAA;IACA,+BAAA;EX6lCV;AACF;AAnrCA;EACI;IACI,UAAA;EAqrCN;EAlrCE;IACI,UAAA;EAorCN;EAjrCE;IACI,UAAA;EAmrCN;EAhrCE;IACI,UAAA;EAkrCN;AACF;AA/qCA;EACI,wBAAA;AAirCJ;;AA9qCA;EACI,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AAirCJ;;AA9qCA;EACI,uBAAA;EACA,oBAAA;EACA,YAAA;AAirCJ;AA/qCI;EACI,6BAAA;AAirCR;AA9qCI;EACI,8BAAA;AAgrCR;;AA5qCA;EACI,yBAAA;AA+qCJ;;AA3qCA;EACI,aAAA;EAEA,WAAA;EAEA,0BAAA;EACA,sBAAA;AA4qCJ;;AAzqCA;EACI,aAAA;EAEA,YAAA;EACA,cAAA;EAEA,0BAAA;EACA,sBAAA;EACA,aAAA;AA0qCJ;;AAtqCA;EACI,gBAAA;EACA,WAAA;AAyqCJ;;AAtqCA;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAyqCJ","sourcesContent":["\n:root[data-theme=\"theme-dark\"] {\n    --bg:#202020;\n    --bg-start: #101010;\n    --bg-end: #808080;\n    --fg: white;\n    --fg-heading: white;\n\n    --hover: rgb(255,200,0);\n    --hover-start: #000050;\n    --hover-end: #0000f0;\n\n    --gradient: linear-gradient(45deg, var(--bg-start), var(--bg-end));\n    --gradient-hover: linear-gradient(223deg, var(--hover-start), var(--hover-end));\n    \n    --button: linear-gradient(45deg, #95a5db, #02015c);\n    --button-text: white;\n    \n    --button-hover: linear-gradient(45deg, #dbda95, #df0d0d);\n    --button-hover-text: black;\n    \n    --button-active: linear-gradient(45deg, #021403, #2cb809);\n    --button-active-text: blue;\n    \n    --button-disabled: linear-gradient(45deg, #0c0c0c, #202020);\n    --button-disabled-text: gray;\n    \n    --gradient-heading: linear-gradient(45deg, #d7e421, #2e0000);\n    --fg-heading: var(--fginv);\n    \n    --strong-color: yellow;\n    --svg-color: rgb(0, 204, 255);\n    --svg-hover-color: red;\n    --dark-color: rgb(116, 75, 0);\n    --faint-color: #9c9b9b;\n    --disabled-color: rgb(85, 82, 82);\n\n    --outline: 0.1rem solid white;\n    --outline-hover: 0.14rem solid yellow;\n    --outline-active: 0.14rem solid red;\n    --outline-disabled: 0.1rem solid black;\n    \n    --overlay-background: rgba(0,0,0, 0.7);\n    --overlay-blur: 25;\n}\n","@use 'dark';\n@use 'light';\n@use 'root';\n@use 'base';\n@use 'layout';\n@use 'outline';\n@use 'dialogs';\n@use 'menu';\n@use 'wrappers';\n@use 'toolbar';\n@use 'edit';\n@use 'theme';\n\n\n@keyframes fadeInOut {\n    0% {\n        opacity: 0;\n    }\n\n    20% {\n        opacity: 1;\n    }\n\n    80% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n.hidden {\n    display: none !important;\n}\n\n.disabled {\n    pointer-events: none;\n    opacity: 0.6;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n.edit-border {\n    outline: var(--outline);\n    border-radius: 0.4em;\n    padding: 1em;\n\n    &:hover {\n        outline: var(--outline-hover);\n    }\n\n    &:active {\n        outline: var(--outline-active);\n    }\n}\n\n.shadow {\n    box-shadow: var(--shadow);\n}\n\n\n.listbox {\n    display: flex;\n\n    gap: 0.5rem;\n\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.selector {\n    display: flex;\n\n    height: auto;\n    padding: 0.5em;\n    \n    -ms-flex-direction: column;\n    flex-direction: column;\n    z-index: 1000;\n}\n\n\n.viewport {\n    overflow: hidden;\n    width: 100%;\n}\n\n.page {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    display: -ms-grid;\n    display: grid;\n    justify-content: start;\n}\n\n\n","    \n:root[data-theme=\"theme-light\"] {\n    --bg:#c0c0c0;\n    --bg-start: #808080;\n    --bg-end: #ffffff;\n    --fg: black;\n    --fg-heading: white;\n\n\n    --hover: rgb(104, 83, 7);\n    --hover-start: #000050;\n    --hover-end: #0000f0;\n\n    --gradient: linear-gradient(45deg, var(--bg-start), var(--bg-end));\n    --gradient-hover: linear-gradient(223deg, var(--hover-start), var(--hover-end));\n    \n    --button: linear-gradient(45deg, #95a5db, #02015c);\n    --button-hover: linear-gradient(45deg, #dbda95, #df0d0d);\n    --button-active: linear-gradient(45deg, #021403, #2cb809);\n    --button-disabled: linear-gradient(45deg, #5c5c5a, #202020);\n    --button-text: white;\n    --button-hover-text: black;\n    \n    --gradient-heading: linear-gradient(45deg, #1a5aa3, #0a0122);\n    --fg-heading: var(--fginv);\n    \n    --comment-color: #1f1100;\n    --strong-color: rgb(0, 38, 255);\n    --reverse-strong-color: rgb(211, 164, 8);\n    --em-color: rgb(38, 24, 56);\n    --svg-color: rgb(81, 212, 245);\n    --svg-hover-color: red;\n    --dark-color: rgb(64, 65, 136);\n    --faint-color: #7c6542;\n    --disabled-color: gray;\n\n    --outline: 0.2rem solid rgb(21, 2, 75);\n    --outline-hover: 0.25rem solid yellow;\n    --outline-disabled: 0.1rem solid black;\n    --outline-active: 0.3rem solid red;\n\n    --overlay-background: rgba(0,0,0, 0.7);\n}\n","@use 'dark';\n@use 'light';\n\n:root {\n    --font-size: 1em;\n    --font-family: Verdana, Geneva, Tahoma, sans-serif;\n\n    --bodyheight: 97vh;\n    --headerheight: 6vh;\n\n    --page-width: 60vw;\n\n\n    --border-radius: 0.4rem;\n    --tb-button-size: 24px;\n\n    --shadow: 12px 10px 12px #000;\n    --near-shadow: 8px 6px 8px #000;\n\n    --edit-zindex: 220;\n    --toolbar-zindex: 210;\n    --overlay-zindex: 200;\n\n}\n\n* {\n    transition: background 0.3s ease, color 0.3s ease;\n    border-radius: var(--border-radius);\n    border: none;\n    outline: none;\n    background: var(--bg);\n    color: var(--fg);\n    font-size: var(--font-size);\n    font-family: var(--font-family);\n    font-weight: bold;\n\n    button {\n        background: var(--button);\n        box-shadow: var(--shadow);\n        color: var(--button-text);\n        font-size: calc(0.8 * var(--font-size));\n        font-weight: bold;\n        height: 1.5rem;\n        width: auto;\n        line-height: 1.4rem;\n        margin: 0em 1em 1em 0.5em;\n        outline: var(--outline);\n        cursor: pointer;\n\n        &:hover {\n            cursor: pointer;\n            background: var(--button-hover);\n            color: var(--button-text-hover);\n        }\n\n        &:focus,\n        &:active {\n            background: var(--button-hover);\n            color: var(--button-text-hover);\n            cursor: default;\n        }\n\n        // &:read-only,\n        // &:disabled {\n        //     background: var(--button-disabled);\n        //     color: var(--button-text-disabled);\n        //     cursor: not-allowed;\n        // }\n    }\n\n    strong,\n    em,\n    a,\n    div,\n    thead,\n    tr,\n    th,\n    p {\n        background: transparent;\n    }\n\n    a {\n        color: var(--strong-color);\n    }\n\n    strong {\n        color: var(--strong-color);\n        font-weight: bolder;\n        margin-left: 0.3em;\n        margin-right: 0.3em;\n    }\n\n    em {\n        color: var(--em-color);\n        font-style: italic;\n        margin-left: 0.3em;\n        margin-right: 0.3em;\n    }\n\n    label {\n        font-weight: bold;\n        background: transparent;\n    }\n\n\n    a {\n        font-weight: bold;\n        text-decoration: none;\n        color: var(--strong-color);\n    }\n\n    figcaption {\n        background: transparent;\n        color: var(--comment-color);\n        font-style: italic;\n    }\n\n    svg {\n        width: 28px;\n        height: auto;\n    }\n\n\n    @media only screen and (max-width: 600px) {\n\n\n        --bodyheight: 97vh;\n        --headerheight: 6vh;\n        --page-width: 98vw;\n\n\n        form {\n            button,\n            input {\n                min-width: unset !important\n            }\n        }\n    }\n\n}","@use 'root';\n\nh1 {\n    font-size: 2em;\n}\n\nh2 {\n    font-size: 1.5em;\n}\n\nh1, h2 \n{\n    font-weight: bold;\n    background: var(--gradient-heading);\n    color: var(--bg);\n}\n\nh3 {\n    background: transparent;\n    color: var(--fg);\n    padding: 0.2em !important;\n}\n\nh1,h2,h3 {\n    box-shadow: var(--shadow);\n    text-align: center;\n    padding: 0.4em;\n    outline: var(--outline);\n    \n    span {\n        color:inherit;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    h1,h2,h3 {\n        font-size: inherit;\n    }\n}\n\nselect {\n    color: var(--fg);\n}\n\nsection {\n    display: inline-flex;\n    position: relative;\n\n    font-weight: bold;\n    width: inherit;\n    min-height: 2rem;\n    margin: 10px;\n    padding: 20px;\n    margin-bottom: 20px;\n    border-radius: 6px;\n\n   \n    .edit {\n        display: flex;\n        -ms-flex-direction: column;\n        flex-direction: column;\n        outline: 2px solid var(--strong-color);\n    }\n\n    .content {\n        display: stretch;\n        width: -webkit-fill-available;\n    }\n\n    .comment {\n        margin: 1em;\n        text-align: center;\n        background-color: transparent;\n        color: var(--fg);\n        border: none;\n        font-style: italic;\n        font-weight: bold;\n\n        &:hover {\n            outline: var(--outline-hover);\n        }\n\n        &:focus {\n            outline: var(--outline-active);\n        }\n    }\n\n}\n\n@media screen and (max-width: 600px) {\n\n    section {\n        width: unset;\n        margin: 0px;\n\n        .content {\n            padding: unset;\n        }\n\n    }\n\n}\n\n@keyframes fadeInOut {\n    0% {\n        opacity: 0;\n    }\n\n    20% {\n        opacity: 1;\n    }\n\n    80% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n@media screen and (max-width: 600px) {\n\n    h1,\n    h2,\n    h3 {\n        padding: 0.2em;\n    }\n}   ","//  =====================================================\n//  BODY \n//  =====================================================\nbody {\n    display: grid;\n\n    height: var(--bodyheight);\n    padding: 10px;\n    gap: 10px;\n\n    grid-template-columns: 1.1fr 4fr 1fr;\n    grid-template-rows: 2fr 30fr 1fr;\n    grid-template-areas: \"header header header\"\n        \"left page right\"\n        \"footer footer footer\";\n}\n\n\n\n//  =====================================================\n//  MIDDLE\n//  =====================================================\n.mid {\n    position: absolute;\n    width: var(--page-width);\n    left: calc((100vw - var(--page-width))/2);\n    top: 0vh;\n\n    nav {\n        display: flex;\n        grid-area: header;\n\n        height: var(--headerheight);\n\n        justify-content: space-between;\n\n        .title {\n            align-content: center;\n            font-weight: bold;\n            font-size: xx-large !important;\n            margin-top: 0.7em;\n            text-shadow: var(--near-shadow);\n        }\n\n        #sitelogo {\n            margin-right: 8px;\n            margin-top: 8px;\n        }\n    }\n\n    main {\n        display: flex;\n        flex-flow: column;\n        margin-top: 1em;\n    }\n\n\n    footer {\n        display: flex;\n        position: fixed;\n\n        background: var(--gradient-heading);\n        color: var(--fg-heading);\n\n        width: calc(0.9*var(--page-width));\n        bottom: 8px;\n        margin-left: 2%;\n        padding-left: 4px;\n        padding-right: 4px;\n\n        align-items: center;\n        box-shadow: var(--shadow);\n        justify-content: space-between;\n\n        .sitename {\n            grid-area: 'left';\n            background: transparent;\n            color: var(--bg);\n        }\n        .sitecontact {\n            grid-area: 'mid';\n            background: transparent;\n            color: var(--bg);\n        }\n\n        .version,\n        a {\n            grid-area: 'right';\n            background: transparent;\n            color: var(--reverse-strong-color) !important;\n            font-size: 1em;\n            font-weight: normal;\n        }\n\n    }\n}\n\n//  =====================================================\n//  LEFT SIDE\n//  =====================================================\n.left {\n    grid-area: left;\n    position: fixed;\n}\n\n\n//  =====================================================\n//  RIGHT SIDE\n//  =====================================================\n.right {\n    display: flex;\n    grid-area: right;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    justify-content: flex-start;\n\n    .help {\n        display: block;\n        position: relative;\n        left: 1em;\n\n        .heading-help {\n            background: var(--gradient-heading);\n            color: var(--bg);\n            box-shadow: var(--shadow);\n            margin: 0em 0em 0em 0.5em;\n            outline: var(--outline);\n        }\n    }\n}\n\n\n@media screen and (max-width: 600px) {\n\n    .mid {\n        left: 0;\n        width: unset;\n\n        nav {\n            .title {\n                font-size: x-large !important;\n            }\n        }\n\n    }\n\n    #sitelogo {\n        width: 14vw;\n        margin-top: 2px;\n        margin-right: 5px;\n    }\n\n    #sitelogo {\n        margin-right: 0px;\n    }\n\n    .left,\n    .right {\n        display: none;\n    }\n\n    body {\n        gap: 7px;\n        padding: 0px;\n        height: 96vh;\n        grid-template-columns: 0fr 1fr 0fr;\n    }\n\n    main {\n        width: 90vw;\n        margin-left: 6px;\n        margin-top: 3em;\n        width: 96vw;\n    }\n\n    footer {\n        width: 93%;\n        height: 4em;\n        justify-content: center;\n        flex-wrap: wrap;\n        font-size: small;\n        flex-direction: column;\n    }\n\n}","\n.outline-btn {\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    opacity: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: opacity 0.5s, transform 0.15s;\n    padding: 4px;\n    background: transparent;\n}\n\n\n/* Fade-in vid hover */\nsection:hover .outline-btn {\n    opacity: 1;\n}\n\nsection:hover .outline-btn:hover {\n    opacity: 1;\n    transform: scale(1.2);\n}\n\n\n.left-top {\n    bottom:unset !important;\n    right: unset !important;\n    left: -24px;\n    top: -12px;\n}\n\n.left-bottom {\n    top:unset !important;\n    right: unset !important;\n    left: -24px;\n    bottom: -24px;\n}\n\n.right-top {\n    left:unset !important;\n    bottom: unset !important;\n    right: -24px;\n    top: -12px;\n}\n\n.right-bottom {\n    left:unset !important;\n    top:unset !important;\n    right: -24px;\n    bottom: -24px;\n}\n\n.save-btn {\n    @extend .right-bottom;\n    stroke: green;\n    fill: green;\n    opacity: 1 !important;\n}\n\n.up-btn {\n    @extend .left-top;\n    fill: var(--fg);\n    stroke:var(--fg);\n}\n\n.public-btn {\n    @extend .left-top;\n    fill: green;\n    stroke:green;\n    opacity: 1 !important;\n}\n\n.down-btn {\n    @extend .left-bottom;\n    fill: var(--fg);\n    stroke: var(--fg);\n}\n\n.private-btn {\n    @extend .left-bottom;\n    fill: red;\n    stroke: red;\n    opacity: 1 !important;\n}\n\n.edit-btn {\n    @extend .right-top;\n    fill: green;\n    stroke: green;\n}\n\n.delete-btn {\n    @extend .right-bottom;\n    stroke: red ;\n    fill: red;\n}\n\n.abort-btn {\n    @extend .right-top;\n    stroke: red ;\n    fill: red;\n    opacity: 1 !important;\n}\n\n\n.red-border {\n    outline: 4px solid red !important;\n}\n\n.green-border {\n    outline: 4px solid green !important;\n}\n",".pop {\n    margin: 20px;\n    top: 50%;\n    left: 50%;\n    position: fixed;\n    box-shadow: var(--shadow);\n    transform: translate(-50%, -50%);\n    z-index: 600;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    font-weight: bold;\n\n\n    div {\n        display: flow-root;\n        text-align: center;\n    }\n\n\n    input {\n        background: var(--gradient);\n        color: var(--fg);\n        height: 1.5rem;\n        width: max-content;\n        line-height: 1rem;\n        margin: 4px;\n        font-weight: bold;\n\n        box-shadow: var(--shadow);\n\n        min-width: var(--min-input-width);\n        max-width: var(--max-input-width);\n\n        &:hover {\n            background: var(--gradient-hover);\n        }\n\n    }\n\n    .error {\n        background: red;\n        color: wheat;\n    }\n\n    .message {\n        position: relative;\n\n    }\n\n    .error {\n        position: relative;\n    }\n}\n\nform {\n    display: flex;\n    flex-direction: column;\n    z-index: 500;\n    padding: 1em 1em 4em 1em;\n    margin-top: 0rem;\n    max-height: unset !important;\n    background: var(--gradient);\n    outline: var(--outline);\n    box-shadow: var(--shadow);\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: calc(0.6 * var(--page-width));\n    min-width: 10vw;\n    width: min-content;\n\n    th {\n        font-weight: bold;\n    }\n\n    td {\n        font-weight: unset;\n        font-size: small;\n    }\n\n    .buttons {\n        display: flex;\n        flex-flow: nowrap;\n        justify-content: space-evenly;\n        flex-direction: column;\n        background: transparent;\n        margin: 1em 0em 0em 0em;\n    }\n\n    button {\n        margin: 1em 1em 1em 1em;\n    }\n\n    input {\n        background: var(--button);\n        outline: var(--outline);\n        height: 1.5em;\n        margin: 0.3em 0em 0.5em 0em;\n        box-shadow: var(--near-shadow);\n        padding: 0em 0em 0em 0.5em;\n\n        &:hover {\n            background: var(--button-hover);\n            color: var(--button-hover-text)\n        }\n\n        &:active &:focus {\n            background: var(--button-active);\n            color: var(--fg)\n        }\n\n    }\n\n    textarea {\n        background: var(--button);\n        outline: var(--outline);\n        box-shadow: var(--near-shadow);\n        resize: none;\n\n        &:hover {\n            background: var(--button-hover);\n            color: var(--button-hover-text)\n        }\n\n        &:active &:focus {\n            background: var(--button-active);\n            color: var(--fg)\n        }\n\n    }\n\n    select {\n        background: var(--button);\n        outline: var(--outline);\n        box-shadow: var(--near-shadow);\n\n        &:hover {\n            background: var(--button-hover);\n            color: var(--button-hover-text)\n        }\n\n        &:active &:focus {\n            background: var(--button-active);\n            color: var(--fg)\n        }\n\n    }\n\n    option {\n        background: var(--fg);\n        color: var(--bg-end);\n\n        &:hover {\n            background: var(--button-hover);\n            color: var(--button-hover-text)\n        }\n\n        &:active &:focus {\n            background: var(--button-active);\n            color: var(--fg)\n        }\n    }\n\n\n    hr {\n        margin: 12px;\n        color: var(--line-color);\n    }\n\n    div {\n        display: grid;\n    }\n\n    .listbox {\n        display: inline;\n\n        select {\n            width: 100%;\n        }\n    }\n\n    iframe {\n        width: auto;\n        height: 200px;\n    }\n\n    .content {\n        display: flex;\n        flex-flow: column;\n    }\n\n    input[type=checkbox] {\n        height: 20px;\n        width: 20px;\n    }\n\n    .inputDiv {\n        display: -ms-grid !important;\n        display: grid !important;\n        -ms-grid-columns: 40% 60%;\n        grid-template-columns: 40% 60%;\n        gap: 0.7rem;\n        margin: 0.7rem;\n    }\n\n    table {\n        display: inline-table;\n        width: 56vw;\n    }\n\n    th {\n        text-align: left;\n    }\n\n}\n\n.formcontainer {\n    display: flex;\n    justify-content: center;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.log {\n    min-width: 98vw !important;\n\n    table {\n        width: 100%;\n    }\n\n    button {\n        position: fixed;\n        bottom: 0em;\n        width: 95%;\n    }\n}\n\n.pageedit {\n    width: 40vw;\n\n\n}\n\n@media only screen and (max-width: 600px) {\n    form {\n\n        button,\n        input {\n            min-width: unset !important\n        }\n    }\n}","aside {\n    flex-flow: column;\n    margin-top: 1rem;\n    display: flex;\n    width: -webkit-fill-available;\n\n    .page {\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        display: -ms-grid;\n        display: flex;\n        justify-content: start;\n        width: inherit;\n    }\n\n    .submenu {\n        display: flex;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        margin: 0.5em 1em 1em 0.5em;\n        width: inherit;\n    }\n\n    .sub {\n        -ms-flex-direction: row;\n        flex-direction: row;\n        flex-wrap: wrap;\n        margin-left: 2rem;\n        width: inherit;\n        display: flex;\n        display: flex;\n    }\n\n    button {\n        width: fit-content;\n    }\n\n    button.group-btn {\n        background: rgb(133, 74, 2) !important;\n    }\n\n    button.page-btn {\n        background: rgb(9, 78, 3) !important;\n    }\n\n    .addGroup {\n        display: flex;\n        flex-direction: column;\n        margin: 4px;\n        height: 2.5em;\n        background: var(--button-hover);\n    }\n\n    .addPage {\n        display: flex;\n        flex-direction: column;\n        margin: 4px;\n        height: 2.5em;\n        background: var(--button-active);\n    }\n\n}\n\nselect {\n    height: 2rem;\n    box-shadow: var(--shadow);\n}\n\n#menutoggler {\n    background-color: var(--dark-color);\n    font-size: xx-large;\n    width: 36px;\n    height: 36px;\n    box-shadow: var(--near-shadow);\n    border-radius: 4px;\n    margin-left: 8px;\n    margin-top: 1rem;\n    line-height: 1em;\n    text-align: center;\n    cursor: pointer;\n}\n\n.addMenu {\n    display: flex;\n    flex-flow: column;\n    margin-top: 1rem;\n\n\n    button {\n        width: inherit;\n    }\n\n}\n\n.adminMenu {\n    display: flex;\n    flex-flow: column;\n    margin-top: 1rem;\n\n\n    button {\n        width: inherit;\n    }\n\n}\n\n@media screen and (max-width: 600px) {\n\n    .addMenu {\n        display: none;\n    }\n\n    #menutoggler {\n        height: auto;\n        width: 32px;\n        box-shadow: var(--near-shadow);\n    }\n\n    aside {\n        margin-top: 0.4em;\n\n        div {\n            margin-left: 0.4em;\n        }\n    }\n}","// =========================================================\n// ADD\n// =========================================================\n.add-wrapper {\n    justify-content: center;\n    transition: scale 0.25s ease-in-out;\n    transform-origin: top left;\n    top: -2em;\n    position: relative;\n    line-height: 0em;\n}\n\n// =========================================================\n// AUDIO\n// =========================================================\n.audio-wrapper {\n    display: block;\n    text-align: center;\n    \n    audio {\n        width: -webkit-fill-available;\n        background: var(--gradient-heading);\n        outline: var(--outline);\n    }\n\n    figcaption {\n\t    background: transparent;\n\t    color: var(--comment-color);\n\t    font-style: italic;\n        margin-top:0.5em;\n    }\n}\n\n// =========================================================\n// HEADING\n// =========================================================\n.heading-wrapper {\n    display: block;\n    text-align: center;\n\n    h1,\n    h2,\n    h3 {\n        background: var(--gradient-heading);\n        color: var(--bg);\n        box-shadow: var(--shadow);\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .heading-wrapper {\n        margin-bottom: 2em;\n    }\n}\n\n// =========================================================\n// IMAGE\n// =========================================================\n.image-wrapper {\n    display: inline-flex !important;\n    transition: scale 0.25s ease-in-out;\n    transform-origin: top left;\n    max-height: 80vh;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        margin-bottom: 1em;\n        max-height: 60vh;\n\n        &:hover {\n            cursor: pointer;\n\n        }\n    }\n\n    figure {\n        width: 100%;\n        display: flex;\n        height: 100%;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        max-width: 80%;\n        max-height: 80%;\n    }\n\n    #image-comment {\n        text-align: center;\n    }\n\n    .clicknote {\n        font-size: small;\n        font-weight: normal;\n        font-style: italic;\n        text-align: center;\n        color: var(--disabled-color);\n        z-index: 100;\n    }\n\n    // canvas:hover {\n    //     outline: var(--outline-hover);\n    // }\n}\n\n\n.fullscreen-image {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.92);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    cursor: zoom-out;\n    width: 100%;\n    height: 100%;\n}\n\n.fullscreen-image img {\n    display: block !important;\n    width: auto !important;\n    height: auto !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n    cursor: zoom-out;\n}\n\n\n@media screen and (max-width: 600px) {\n\n    .image {\n        display: -ms-grid;\n        display: grid;\n        -ms-grid-columns: 100%;\n        grid-template-columns: 100%;\n        flex-flow: wrap;\n        justify-content: center;\n    }\n}\n\n// =========================================================\n// LIST\n// =========================================================\n\n.list-wrapper {\n    padding: 0em 0em 0em 1em;\n}\n\n// =========================================================\n// SPOTIFY\n// =========================================================\n.spotify-wrapper {\n    display: block;\n    text-align: center;\n    aspect-ratio: 16/1;\n\n    figcaption {\n        margin-top: 1em;\n        position: relative;\n    }\n\n    iframe {\n        width: -webkit-fill-available;\n        height: 153px;\n    }\n}\n\n@media screen and (max-width: 600px) {\n\n    .spotify-wrapper {\n        figcaption {\n            margin-top: 5em;\n        }\n    }\n}\n\n\n// =========================================================\n// HTML / TEXT\n// =========================================================\n.text-wrapper {\n    display: block;\n\n    a {\n        cursor: pointer;\n        color: var(--strong-color);\n    }\n\n}\n\n// =========================================================\n// VIDEO\n// =========================================================\n.video-wrapper {\n    display: block;\n    justify-content: center;\n    width: -moz-available;\n    max-width: 100%;\n    max-height: 100%;\n    margin: auto;\n\n    figure {\n        margin: 0;\n\n        video {\n            width: -webkit-fill-available;\n            width: -moz-available;\n            width: stretch;\n        }\n\n        figcaption {\n            text-align: center;\n            margin-top: 1em;\n        }\n    }\n\n}\n\n@media screen and (max-width: 600px) {\n\n    .video-wrapper {\n        width: 80vw;\n    }\n}\n\n\n// =========================================================\n// YOUTUBE\n// =========================================================\n.youtube-wrapper {\n    aspect-ratio: 16/9;\n\theight: fit-content;\n\n    iframe {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .youtube figcaption {\n        margin-top: 5em;\n    }\n}","\n.toolbar {\n\tdisplay: flex;\n\theight: var(--tb-button-size);\n\tz-index: var(--toolbar-zindex);\n\tmargin-bottom: 0.5em;\n\tmargin-top: 0.1em;\n\tjustify-content: space-evenly;\n}\n\n.tbgroup {\n\tflex-flow: row;\n\tmargin: -4px 4px 0px 10px;\n\tpadding: 4px;\n\theight: 32px;\n}\n\n.toolbar button {\n\twidth: 2em !important;\n\tbox-shadow: 4px 6px 5px #000;\n\tmargin: 0.1em;\n\tmargin: 2px;\n\theight: 2em !important;\n}\n\n.toolbar button:hover {\n    scale: 1.2;\n    box-shadow: var(--shadow);\n}\n\n.toolbar-btn {\n    height: 1.5rem;\n    line-height: 1rem;\n    margin: 0.4rem;\n    box-shadow: var(--shadow);\n    width: max-content;\n    padding-right: 1em;\n}\n\n.btnNone {\n    box-shadow: none;\n}\n\n.icon {\n    margin-right: 0.5em;\n}\n\n",".editTools {\n    outline: var(--outline);\n    padding: 0.5em 0em 0em 0em;\n    background: var(--bg-start);\n    box-shadow: var(--shadow);\n    margin: 0em 0em 1em 0em;\n    z-index: 500;\n\n}\n\n    .disabled {\n            background: var(--button-disabled);\n            color: var(--button-disabled-text);\n            cursor: not-allowed;\n        }\n\n    .active {\n            background: var(--button-active);\n            color: var(--button-active-text);\n            cursor: pointer;\n\n        }\n.edit-container {\n    padding: 1em;\n}\n\n\n.edit {\n    z-index: var(--edit-zindex);\n    position: relative;\n    box-shadow: var(--shadow);\n}\n\n.debugger {\n    display: block;\n    width: 18vw;\n    height: auto;\n    z-index: 99999;\n    position: fixed;\n    left: 0.1vw;\n    top: 6vh;\n    padding: 1em;\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    -webkit-backdrop-filter: var(--overlay-blur);\n    backdrop-filter: var(--overlay-blur);\n    z-index: var(--overlay-zindex);\n    background: var(--overlay-background);\n}\n\n.border-img {\n    display: block;\n}\n\n.border-img:hover {\n    display: block;\n}\n\n","\n.theme {\n    display: flex;\n    background: transparent;\n\n    -ms-flex-direction: column;\n    flex-direction: column;\n    align-items: center;\n}\n\n.theme-selectors {\n    display: flex;\n    \n    -ms-flex-direction: column;\n    flex-direction: row;\n\n}\n\n.theme-dark {\n    background: linear-gradient(45deg, rgb(126, 126, 126), black) !important;\n}\n\n.theme-light {\n    background: linear-gradient(45deg, rgb(92, 91, 91), rgb(214, 213, 213)) !important;\n}\n\n\n.theme-dark,\n.theme-light {\n    width: 24px;\n    height: 24px;\n    margin-top: 1em;\n\n    border-radius: 50%;\n}\n\n\n.theme-container {\n    height: 2em;\n    width: 80%;\n    display: flex;\n    justify-content: space-around;\n    margin-left: 10%;\n    margin-bottom: 2%;\n}\n\n.theme-item {\n    width: 1.5em;\n    margin-left: 0.5em;\n    border-radius: 8px;\n    box-shadow: var(--shadow);\n    height: 1.5em;\n    border-radius: 50%;\n    margin-top: 0.2em;\n}\n\n.theme-switcher {\n    padding: 0.5rem 1rem;\n    border-radius: 0.4rem;\n    cursor: pointer;\n    border: none;\n    background: var(--button);\n    color: var(--button-text);\n\n    &:hover {\n        background: var(--button-hover);\n        color: var(--button-hover-text);\n    }\n\n    .page {\n        margin: 4px;\n    }\n}\n.theme-dark {\n    background: linear-gradient(45deg, rgb(126, 126, 126), black) !important;\n}\n\n.theme-light {\n    background: linear-gradient(45deg, rgb(92, 91, 91), rgb(214, 213, 213)) !important;\n}\n\n@media screen and (max-width: 600px) {\n\n    .theme-dark,\n    .theme-light{\n        width: 10px;\n        height: 10px;\n        margin-top: 1em;\n        margin-left: 0.5em;\n    }\n\n    .theme-switcher {\n        background: var(--button);\n        color: var(--button-text);\n        font-size: 1rem;\n        margin-left: 0.3em;\n\n        &:hover {\n            background: var(--button-hover);\n            color: var(--button-hover-text);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
